<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="abrirModal()">
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Anexo
            </span>
        </b-button>
		<b-modal
			v-model="showModal"
			id="modalInserirAnexo"
			hide-footer
		>
			<div slot="modal-title">
				Anexo -
				<b-badge variant="warning">Inserir</b-badge>
			</div>
			<anexo-parcelamento-form
				:anexo="anexo"
                :parcelamento="parcelamento"
				:showModal="showModal"
				@modalFechado="showModal = false"
				@obterAnexosAtualizados="$emit('obterAnexosAtualizados')"
			></anexo-parcelamento-form>
		</b-modal>
    </div>
</template>

<script>
import AnexoParcelamentoForm from './AnexoParcelamentoForm'

export default {
	components: {
		AnexoParcelamentoForm
	},

	props: {
		anexo: {
			type: Object,
			default: () => ({})
		},

        parcelamento: {
			type: Object,
			default: () => ({})
		}
	},
	
	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
